/* =========================================================
ZEVRINO PRODUCT SYSTEM V2
PAINT PACKAGE SELECTOR

Yalnızca paint ürün ailesinde kullanılır.

Görev:
- Özel paket kartlarını yönetir
- Gerçek Shopify paket select'ini kontrol eder
- Seçili renk + paket kombinasyonundan gerçek varyantı bulur
- Paket fiyatını günceller
- Compare at price günceller
- İndirim yüzdesini hesaplar
- Stok durumunu günceller
- Paket varyant ID'sini günceller
- Paket varyant görselini günceller
- Renk değişince tüm paket kartlarını yeniden hesaplar
- Paket kaplama alanını otomatik hesaplar

Gereksinimler:
- dekofar-v2-core.js önce yüklenmelidir.
- Galeri görseli kullanılacaksa
  dekofar-v2-gallery.js önce yüklenmelidir.

ÖNEMLİ:
Gerçek Shopify select'leri tek source of truth olarak korunur.
========================================================= */


function dekofarV2InitPackageSelectors(scope) {

  const root =
    scope || document;

  dekofarV2InitPaintInfoVariantImages(
    root
  );


  root
    .querySelectorAll(
      '[data-dekofar-v2-package-selector]'
    )
    .forEach(
      (selector) => {


        /* =====================================================
           DAHA ÖNCE BAŞLATILDI MI?
        ===================================================== */

        if (
          selector.dataset
            .dekofarV2PackageInitialized ===
          'true'
        ) {

          return;
        }



        /* =====================================================
           ROOT ELEMENTLER
        ===================================================== */

        const optionWrapper =
          selector.closest(
            '[data-dekofar-v2-option]'
          );


        const productRoot =
          selector.closest(
            '.dekofar-v2-product'
          );


        if (
          !optionWrapper ||
          !productRoot
        ) {

          return;
        }



        /* =====================================================
           NATIVE PACKAGE SELECT
        ===================================================== */

        const select =
          optionWrapper.querySelector(
            'select[data-option-position]'
          );


        const selectedValueElement =
          optionWrapper.querySelector(
            '[data-dekofar-v2-package-selected-value]'
          );


        const buttons = [
          ...selector.querySelectorAll(
            '[data-dekofar-v2-package-value]'
          )
        ];



        /* =====================================================
           TÜM OPTION SELECTLER
        ===================================================== */

        const allOptionSelects = [
          ...productRoot.querySelectorAll(
            'select[data-option-position]'
          )
        ];



        /* =====================================================
           RENK SELECT
        ===================================================== */

        const colorSelect =
          productRoot.querySelector(
            '.dekofar-v2-option--color select[data-option-position]'
          );



        /* =====================================================
           PRODUCT DATA
        ===================================================== */

        const productData =
          dekofarV2ReadProductData(
            productRoot
          );


        if (
          !select ||
          !buttons.length ||
          !allOptionSelects.length ||
          !productData ||
          !Array.isArray(
            productData.variants
          )
        ) {

          return;
        }


        /* =====================================================
           FREE SHIPPING

           Öncelik product context içindeki varyant değeridir.
           Context değeri yoksa 999 TL yedek sınırı kullanılır.
           Shopify fiyatları kuruş cinsindedir.
        ===================================================== */

        const freeShippingThreshold =
          Number.isFinite(
            Number(
              productData.free_shipping_limit
            )
          )
            ? Number(
                productData.free_shipping_limit
              )
            : 99900;


        const variantHasFreeShipping =
          (variant) => {

            if (!variant) {
              return false;
            }

            if (
              typeof variant.free_shipping ===
              'boolean'
            ) {
              return variant.free_shipping;
            }

            const price =
              Number(variant.price);

            return (
              Number.isFinite(price) &&
              price >= freeShippingThreshold
            );
          };


        /* =====================================================
           CART DISCOUNT CAMPAIGN
           1.500 TL ve üzeri ürünlerde sepette 200 TL indirim.
           Sadece kart üzerindeki sunumu değiştirir; Shopify
           varyant fiyatını veya sepete eklenen fiyatı değiştirmez.
        ===================================================== */

        const cartDiscountEnabled =
          productData.cart_discount_enabled !== false;

        const cartDiscountThreshold =
          Number(productData.cart_discount_threshold || 150000);

        const cartDiscountType =
          String(productData.cart_discount_type || 'fixed');

        const cartDiscountValue =
          Number(productData.cart_discount_value || 200);

        const cartDiscountAmount =
          Number(productData.cart_discount_amount || Math.round(cartDiscountValue * 100));

        const hasCartDiscountCampaign =
          (price) => {
            const numericPrice = Number(price);

            if (
              !cartDiscountEnabled ||
              !Number.isFinite(numericPrice) ||
              !Number.isFinite(cartDiscountThreshold) ||
              numericPrice < cartDiscountThreshold ||
              !Number.isFinite(cartDiscountValue) ||
              cartDiscountValue <= 0
            ) {
              return false;
            }

            if (cartDiscountType === 'percentage') {
              return cartDiscountValue < 100;
            }

            return (
              Number.isFinite(cartDiscountAmount) &&
              cartDiscountAmount > 0 &&
              numericPrice > cartDiscountAmount
            );
          };

        const cartDiscountPrice =
          (price) => {
            const numericPrice = Number(price);

            if (!hasCartDiscountCampaign(numericPrice)) {
              return numericPrice;
            }

            if (cartDiscountType === 'percentage') {
              return Math.max(
                0,
                Math.round(numericPrice * (100 - cartDiscountValue) / 100)
              );
            }

            return numericPrice - cartDiscountAmount;
          };

        const cartDiscountBadgeText =
          () => {
            if (cartDiscountType === 'percentage') {
              return `%${new Intl.NumberFormat('tr-TR').format(cartDiscountValue)} İNDİRİM`;
            }

            return `${new Intl.NumberFormat('tr-TR').format(cartDiscountValue)} TL İNDİRİM`;
          };


        /* =====================================================
           PACKAGE SELECT INDEX
        ===================================================== */

        const packageSelectIndex =
          allOptionSelects.indexOf(
            select
          );



        /* =====================================================
           SELECTED OPTIONS
        ===================================================== */

        const getSelectedOptions =
          () => {

            return allOptionSelects.map(
              (optionSelect) =>
                optionSelect.value
            );
          };



        /* =====================================================
           FIND VARIANT FOR PACKAGE
        ===================================================== */

        const findVariantForPackage =
          (packageValue) => {


            if (
              packageSelectIndex < 0
            ) {

              return null;
            }


            const candidateOptions =
              getSelectedOptions();


            candidateOptions[
              packageSelectIndex
            ] =
              packageValue;


            return dekofarV2FindVariant(
              productData,
              candidateOptions
            );
          };



        /* =====================================================
           GALLERY MEDIA HELPER
        ===================================================== */

        const getGalleryMediaImage =
          (mediaId) => {


            if (!mediaId) {

              return null;
            }


            const gallery =
              productRoot.querySelector(
                '[data-dekofar-v2-gallery]'
              );


            if (!gallery) {

              return null;
            }


            const galleryItem =
              gallery.querySelector(
                `[data-dekofar-v2-gallery-item][data-media-id="${String(
                  mediaId
                )}"]`
              );


            const galleryImage =
              galleryItem
                ? galleryItem.querySelector(
                    'img'
                  )
                : null;


            if (galleryImage) {

              return {

                src:
                  galleryImage.currentSrc ||
                  galleryImage.src ||
                  '',

                srcset:
                  galleryImage.getAttribute(
                    'srcset'
                  ) || '',

                alt:
                  galleryImage.alt ||
                  ''

              };
            }


            const thumbnail =
              gallery.querySelector(
                `[data-dekofar-v2-gallery-thumbnail][data-media-id="${String(
                  mediaId
                )}"]`
              );


            const thumbnailImage =
              thumbnail
                ? thumbnail.querySelector(
                    'img'
                  )
                : null;


            if (thumbnailImage) {

              return {

                src:
                  thumbnailImage.currentSrc ||
                  thumbnailImage.src ||
                  '',

                srcset:
                  thumbnailImage.getAttribute(
                    'srcset'
                  ) || '',

                alt:
                  thumbnailImage.alt ||
                  ''

              };
            }


            return null;
          };



        /* =====================================================
           PACKAGE MEDIA
        ===================================================== */

        const updatePackageMedia =
          (
            button,
            variant
          ) => {


            const mediaWrapper =
              button.querySelector(
                '[data-dekofar-v2-package-media]'
              );


            if (!mediaWrapper) {

              return;
            }


            if (
              mediaWrapper
                .dekofarV2DefaultHtml ===
              undefined
            ) {

              mediaWrapper
                .dekofarV2DefaultHtml =
                mediaWrapper.innerHTML;
            }


            const mediaId =
              dekofarV2GetFeaturedMediaId(
                variant
              );


            if (!mediaId) {

              button.removeAttribute(
                'data-dekofar-v2-package-media-id'
              );


              mediaWrapper.innerHTML =
                mediaWrapper
                  .dekofarV2DefaultHtml;


              return;
            }


            button.setAttribute(
              'data-dekofar-v2-package-media-id',
              String(
                mediaId
              )
            );


            const mediaImage =
              getGalleryMediaImage(
                mediaId
              );


            if (
              !mediaImage ||
              !mediaImage.src
            ) {

              return;
            }


            let image =
              mediaWrapper.querySelector(
                '.dekofar-v2-package-card__image'
              );


            if (!image) {

              mediaWrapper.innerHTML =
                '';


              image =
                document.createElement(
                  'img'
                );


              image.className =
                'dekofar-v2-package-card__image';


              image.loading =
                'lazy';


              mediaWrapper.appendChild(
                image
              );
            }


            image.src =
              mediaImage.src;


            if (
              mediaImage.srcset
            ) {

              image.setAttribute(
                'srcset',
                mediaImage.srcset
              );

            } else {

              image.removeAttribute(
                'srcset'
              );
            }


            image.alt =
              mediaImage.alt ||
              '';
          };



        /* =====================================================
           SELECTED PACKAGE UI
        ===================================================== */

        const updateButtons =
          (value) => {


            buttons.forEach(
              (button) => {


                const buttonValue =
                  button.getAttribute(
                    'data-dekofar-v2-package-value'
                  );


                const isSelected =
                  buttonValue ===
                  value;


                button.classList.toggle(
                  'is-selected',
                  isSelected
                );


                button.setAttribute(
                  'aria-pressed',
                  isSelected
                    ? 'true'
                    : 'false'
                );

              }
            );


            if (
              selectedValueElement
            ) {

              selectedValueElement
                .textContent =
                value;
            }
          };



        /* =====================================================
           COVERAGE HELPERS
        ===================================================== */


        function normalizeCoverageUnit(
          unit
        ) {

          const value =
            String(
              unit || ''
            )
              .toLowerCase()
              .trim();


          if (
            value === 'litre' ||
            value === 'liter' ||
            value === 'lt' ||
            value === 'l'
          ) {

            return 'l';
          }


          if (
            value === 'kilogram' ||
            value === 'kilo' ||
            value === 'kg'
          ) {

            return 'kg';
          }


          return value;
        }



        function formatCoverageValue(
          number
        ) {


          if (
            !Number.isFinite(
              number
            )
          ) {

            return '';
          }


          if (
            Math.abs(
              number -
              Math.round(
                number
              )
            ) < 0.001
          ) {

            return String(
              Math.round(
                number
              )
            );
          }


          return Number(
            number.toFixed(
              2
            )
          ).toLocaleString(
            'tr-TR',
            {
              minimumFractionDigits:
                0,

              maximumFractionDigits:
                2
            }
          );
        }



        /* =====================================================
           UPDATE PACKAGE COVERAGE
        ===================================================== */

        const updatePackageCoverage =
          (
            coverageElement,
            packageValue
          ) => {


            if (
              !coverageElement
            ) {

              return;
            }


            try {


              /* ---------------------------------------------
                 PAINT CALCULATOR
              --------------------------------------------- */

              const paintCalculator =
                productRoot.querySelector(
                  '[data-dekofar-v2-paint-calculator]'
                );


              if (
                !paintCalculator
              ) {

                coverageElement
                  .textContent =
                  '';

                coverageElement.hidden =
                  true;

                return;
              }



              /* ---------------------------------------------
                 V2 BOYA HESAPLAMA DEĞERİ
              --------------------------------------------- */

              const rawCoverage =
                String(
                  paintCalculator.getAttribute(
                    'data-coverage-per-unit'
                  ) || ''
                )
                  .trim();



              /* ---------------------------------------------
                 V2 BOYA HESAPLAMA BİRİMİ
              --------------------------------------------- */

              const coverageUnit =
                String(
                  paintCalculator.getAttribute(
                    'data-coverage-unit'
                  ) || ''
                )
                  .trim();



              /* ---------------------------------------------
                 PAKET MİKTARI

                 0.75 L -> 0.75
                 2.5 L  -> 2.5
                 7.5 L  -> 7.5
                 15 L   -> 15
                 3 KG   -> 3
              --------------------------------------------- */

              const packageNumberMatch =
                String(
                  packageValue || ''
                ).match(
                  /(\d+(?:[.,]\d+)?)/
                );


              const packageAmount =
                packageNumberMatch
                  ? parseFloat(
                      packageNumberMatch[
                        1
                      ].replace(
                        ',',
                        '.'
                      )
                    )
                  : NaN;



              /* ---------------------------------------------
                 PAKET BİRİMİ
              --------------------------------------------- */

              const packageUnitRaw =
                String(
                  packageValue || ''
                )
                  .replace(
                    /[\d.,\s]/g,
                    ''
                  )
                  .trim();


              const packageUnit =
                normalizeCoverageUnit(
                  packageUnitRaw
                );


              const calculatorUnit =
                normalizeCoverageUnit(
                  coverageUnit
                );


              /* ---------------------------------------------
                 COVERAGE DEĞERLERİNİ PARSE ET

                 11
                 11-14
                 11–14
                 11,5-14,5
              --------------------------------------------- */

              const coverageMatches =
                String(
                  rawCoverage
                ).match(
                  /\d+(?:[.,]\d+)?/g
                ) || [];


              const coverageValues =
                coverageMatches.map(
                  function (
                    value
                  ) {

                    return parseFloat(
                      value.replace(
                        ',',
                        '.'
                      )
                    );
                  }
                );


              const minCoverage =
                coverageValues.length >
                0
                  ? coverageValues[
                      0
                    ]
                  : NaN;


              const maxCoverage =
                coverageValues.length >
                1
                  ? coverageValues[
                      1
                    ]
                  : minCoverage;


              /* ---------------------------------------------
                 BİRİM KONTROLÜ
              --------------------------------------------- */

              const unitsMatch =
                !calculatorUnit ||
                !packageUnit ||
                calculatorUnit ===
                  packageUnit;


              /* ---------------------------------------------
                 GEÇERLİ VERİ KONTROLÜ
              --------------------------------------------- */

              const hasValidData =
                Number.isFinite(
                  packageAmount
                ) &&
                packageAmount >
                  0 &&
                Number.isFinite(
                  minCoverage
                ) &&
                minCoverage >
                  0 &&
                Number.isFinite(
                  maxCoverage
                ) &&
                maxCoverage >
                  0 &&
                unitsMatch;


              if (
                !hasValidData
              ) {

                coverageElement
                  .textContent =
                  '';

                coverageElement.hidden =
                  true;

                return;
              }


              /* ---------------------------------------------
                 HESAPLAMA

                 Metafield değeri tek kat
                 kaplama alanı olarak kabul edilir.

                 Örnek:
                 1 Kg x 11 m² = 11 m²
                 3 Kg x 11 m² = 33 m²
                 18 Kg x 11 m² = 198 m²
              --------------------------------------------- */

              const calculatedMin =
                packageAmount *
                minCoverage;


              const calculatedMax =
                packageAmount *
                maxCoverage;


              /* ---------------------------------------------
                 TEK COVERAGE DEĞERİ
              --------------------------------------------- */

              if (
                Math.abs(
                  calculatedMin -
                  calculatedMax
                ) < 0.001
              ) {

                coverageElement
                  .textContent =
                  'Yaklaşık ' +
                  formatCoverageValue(
                    calculatedMin
                  ) +
                  ' m² alan için yeterlidir.';

              }


              /* ---------------------------------------------
                 COVERAGE ARALIĞI
              --------------------------------------------- */

              else {

                coverageElement
                  .textContent =
                  'Yaklaşık ' +
                  formatCoverageValue(
                    calculatedMin
                  ) +
                  '–' +
                  formatCoverageValue(
                    calculatedMax
                  ) +
                  ' m² alan için yeterlidir.';

              }


              coverageElement.hidden =
                false;


            } catch (
              error
            ) {


              /*
               * Coverage hesabı bozulsa bile
               * paket seçimi çalışmaya devam eder.
               */


              console.warn(
                'Dekofar V2: Paket kaplama hesabı yapılamadı.',
                error
              );


              coverageElement
                .textContent =
                '';


              coverageElement.hidden =
                true;

            }
          };

        /* =====================================================
           UPDATE PACKAGE CARDS
        ===================================================== */

        const updatePackageCards =
          () => {


            const selectedColor =
              colorSelect
                ? colorSelect.value
                : '';


            buttons.forEach(
              (button) => {


                const packageValue =
                  button.getAttribute(
                    'data-dekofar-v2-package-value'
                  );


                if (
                  !packageValue
                ) {

                  return;
                }



                /* ---------------------------------------------
                   VARIANT BUL
                --------------------------------------------- */

                const variant =
                  findVariantForPackage(
                    packageValue
                  );



                /* ---------------------------------------------
                   CARD ELEMENTLERİ
                --------------------------------------------- */

                const priceElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-price]'
                  );


                const compareElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-compare-price]'
                  );


                const discountElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-discount]'
                  );


                const colorElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-color]'
                  );


                const coverageElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-coverage]'
                  );


                const soldOutElement =
                  button.querySelector(
                    '[data-dekofar-v2-sold-out]'
                  );


                const shippingElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-shipping]'
                  );

                const cartCampaignElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-cart-campaign]'
                  );

                const cartCampaignPriceElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-cart-campaign-price]'
                  );

                const cartCampaignBadgeElement =
                  button.querySelector(
                    '[data-dekofar-v2-package-cart-campaign-badge]'
                  );



                /* ---------------------------------------------
                   COLOR
                --------------------------------------------- */

                if (
                  colorElement
                ) {

                  colorElement
                    .textContent =
                    selectedColor;


                  colorElement.hidden =
                    !selectedColor;
                }



                /* ---------------------------------------------
                   COVERAGE
                --------------------------------------------- */

                updatePackageCoverage(
                  coverageElement,
                  packageValue
                );



                /* ---------------------------------------------
                   VARIANT DOES NOT EXIST
                --------------------------------------------- */

                if (
                  !variant
                ) {


                  if (
                    priceElement
                  ) {

                    priceElement
                      .textContent =
                      '';
                  }


                  if (
                    compareElement
                  ) {

                    compareElement
                      .textContent =
                      '';

                    compareElement.hidden =
                      true;
                  }


                  if (
                    discountElement
                  ) {

                    discountElement
                      .textContent =
                      '';

                    discountElement.hidden =
                      true;
                  }


                  if (
                    shippingElement
                  ) {

                    shippingElement
                      .textContent =
                      '';

                    shippingElement.hidden =
                      true;
                  }

                  if (cartCampaignElement) {
                    cartCampaignElement.hidden = true;
                  }

                  if (cartCampaignPriceElement) {
                    cartCampaignPriceElement.textContent = '';
                  }

                  if (priceElement) {
                    priceElement.classList.remove('is-cart-campaign-base');
                  }


                  button.disabled =
                    true;


                  button.classList.add(
                    'is-unavailable'
                  );


                  button.setAttribute(
                    'aria-disabled',
                    'true'
                  );


                  if (
                    soldOutElement
                  ) {

                    soldOutElement.hidden =
                      false;
                  }


                  button.removeAttribute(
                    'data-dekofar-v2-package-variant-id'
                  );


                  button.removeAttribute(
                    'data-dekofar-v2-package-free-shipping'
                  );


                  button.removeAttribute(
                    'data-dekofar-v2-package-media-id'
                  );


                  return;
                }



                /* ---------------------------------------------
                   VARIANT ID
                --------------------------------------------- */

                button.setAttribute(
                  'data-dekofar-v2-package-variant-id',
                  String(
                    variant.id
                  )
                );


                button.setAttribute(
                  'data-dekofar-v2-package-free-shipping',
                  variantHasFreeShipping(
                    variant
                  )
                    ? 'true'
                    : 'false'
                );



                /* ---------------------------------------------
                   PRICE + CART CAMPAIGN
                --------------------------------------------- */

                const currentPrice =
                  Number(variant.price);

                const cartCampaignActive =
                  hasCartDiscountCampaign(currentPrice);

                if (priceElement) {
                  priceElement.textContent =
                    dekofarV2FormatMoney(currentPrice);

                  priceElement.classList.toggle(
                    'is-cart-campaign-base',
                    cartCampaignActive
                  );
                }

                if (cartCampaignElement) {
                  cartCampaignElement.hidden =
                    !cartCampaignActive;
                }

                if (cartCampaignPriceElement) {
                  cartCampaignPriceElement.textContent =
                    cartCampaignActive
                      ? dekofarV2FormatMoney(
                          cartDiscountPrice(currentPrice)
                        )
                      : '';
                }

                if (cartCampaignBadgeElement) {
                  cartCampaignBadgeElement.textContent =
                    cartCampaignActive
                      ? cartDiscountBadgeText()
                      : '';
                }


                /* ---------------------------------------------
                   COMPARE PRICE + PRODUCT DISCOUNT
                   Sepet kampanyası aktifse eski ürün indirimi
                   ikinci planda kalır; kartı kalabalıklaştırmayız.
                --------------------------------------------- */

                const compareAtPrice =
                  dekofarV2GetCompareAtPrice(variant);

                const hasComparePrice =
                  Number.isFinite(compareAtPrice) &&
                  Number.isFinite(currentPrice) &&
                  compareAtPrice > currentPrice;

                if (compareElement) {
                  compareElement.hidden =
                    cartCampaignActive || !hasComparePrice;

                  compareElement.textContent =
                    (!cartCampaignActive && hasComparePrice)
                      ? dekofarV2FormatMoney(compareAtPrice)
                      : '';
                }

                if (discountElement) {
                  if (!cartCampaignActive && hasComparePrice) {
                    const discountPercentage =
                      Math.round(
                        ((compareAtPrice - currentPrice) /
                          compareAtPrice) * 100
                      );

                    discountElement.textContent =
                      `%${discountPercentage} AVANTAJ`;
                    discountElement.hidden = false;
                  } else {
                    discountElement.textContent = '';
                    discountElement.hidden = true;
                  }
                }


                /* ---------------------------------------------
                   STOCK
                --------------------------------------------- */

                const isAvailable =
                  Boolean(
                    variant.available
                  );


                button.disabled =
                  !isAvailable;


                button.classList.toggle(
                  'is-unavailable',
                  !isAvailable
                );


                button.setAttribute(
                  'aria-disabled',
                  isAvailable
                    ? 'false'
                    : 'true'
                );


                if (
                  soldOutElement
                ) {

                  soldOutElement.hidden =
                    isAvailable;
                }



                /* ---------------------------------------------
                   SHIPPING
                --------------------------------------------- */

                if (
                  shippingElement
                ) {


                  const hasFreeShipping =
                    variantHasFreeShipping(
                      variant
                    );


                  shippingElement.hidden =
                    !hasFreeShipping;


                  shippingElement
                    .textContent =
                    hasFreeShipping
                      ? '🚚 KARGO BEDAVA'
                      : '';
                }



                /* ---------------------------------------------
                   VARIANT IMAGE
                --------------------------------------------- */

                updatePackageMedia(
                  button,
                  variant
                );

              }
            );
          };



        /* =====================================================
           PACKAGE CLICK
        ===================================================== */

        buttons.forEach(
          (button) => {


            button.addEventListener(
              'click',
              () => {


                if (
                  button.disabled
                ) {

                  return;
                }


                const value =
                  button.getAttribute(
                    'data-dekofar-v2-package-value'
                  );


                if (
                  !value
                ) {

                  return;
                }


                /*
                 * Gerçek Shopify select
                 * tek source of truth.
                 */

                select.value =
                  value;


                select.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles:
                        true
                    }
                  )
                );

              }
            );

          }
        );



        /* =====================================================
           PACKAGE SELECT CHANGE
        ===================================================== */

        select.addEventListener(
          'change',
          () => {


            updateButtons(
              select.value
            );


            updatePackageCards();

          }
        );



        /* =====================================================
           COLOR CHANGE
        ===================================================== */

        if (
          colorSelect
        ) {


          colorSelect.addEventListener(
            'change',
            updatePackageCards
          );

        }



        /* =====================================================
           INITIAL RENDER
        ===================================================== */

        updateButtons(
          select.value
        );


        updatePackageCards();

      }
    );
}


/* =========================================================
   PAINT INFO — SELECTED VARIANT IMAGE
========================================================= */

function dekofarV2InitPaintInfoVariantImages(scope) {
  const root = scope || document;

  root
    .querySelectorAll('[data-dekofar-v2-paint-info]')
    .forEach((paintInfo) => {
      if (
        paintInfo.dataset.dekofarV2PaintInfoImageInitialized ===
        'true'
      ) {
        return;
      }

      const image = paintInfo.querySelector(
        '[data-dekofar-v2-paint-info-image]'
      );

      const imageDataElement = paintInfo.querySelector(
        '[data-dekofar-v2-paint-info-images]'
      );

      const productRoot = paintInfo.closest(
        '.dekofar-v2-product'
      );

      if (!image || !imageDataElement || !productRoot) {
        return;
      }

      let imageData = null;

      try {
        imageData = JSON.parse(
          imageDataElement.textContent
        );
      } catch (error) {
        imageData = null;
      }

      if (!imageData || !imageData.variants) {
        return;
      }

      paintInfo.dataset.dekofarV2PaintInfoImageInitialized =
        'true';

      const updateImage = (variant) => {
        if (
          !variant ||
          variant.id === undefined ||
          variant.id === null
        ) {
          return;
        }

        const nextImage =
          imageData.variants[String(variant.id)] ||
          imageData.fallback;

        if (
          !nextImage ||
          image.getAttribute('src') === nextImage
        ) {
          return;
        }

        image.classList.add('is-changing');

        const preload = new Image();

        preload.onload = () => {
          image.src = nextImage;

          if (variant.title) {
            image.alt = variant.title;
          }

          requestAnimationFrame(() => {
            image.classList.remove('is-changing');
          });
        };

        preload.onerror = () => {
          image.classList.remove('is-changing');
        };

        preload.src = nextImage;
      };

      productRoot.addEventListener(
        'dekofar:v2:variant-change',
        (event) => {
          const variant =
            event.detail && event.detail.variant
              ? event.detail.variant
              : null;

          updateImage(variant);
        }
      );

      const variantInput = productRoot.querySelector(
        '[data-dekofar-v2-variant-id]'
      );

      if (variantInput) {
        variantInput.addEventListener('change', () => {
          updateImage({ id: variantInput.value });
        });
      }
    });
}
